var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['jquery', 'core', 'collection/ledger-account-category', 'app-common/util/cache-manager'], function($, core, LedgerAccountCategoryCollection, cacheManager) {
  var CachedLedgerAccountCategoryCollection;
  CachedLedgerAccountCategoryCollection = (function(_super) {

    __extends(CachedLedgerAccountCategoryCollection, _super);

    function CachedLedgerAccountCategoryCollection() {
      CachedLedgerAccountCategoryCollection.__super__.constructor.apply(this, arguments);
    }

    CachedLedgerAccountCategoryCollection.prototype.initialize = function(models, options) {
      CachedLedgerAccountCategoryCollection.__super__.initialize.call(this, models, options);
      return cacheManager.wrapFetch(this, 'ledgerAccountCategory');
    };

    return CachedLedgerAccountCategoryCollection;

  })(LedgerAccountCategoryCollection);
  return CachedLedgerAccountCategoryCollection;
});
